<template>
    <div class="ba6-mailingboss-statistics">
        <builderall-loader :loading="showLoading">
            <div class="ba6-card">
                <div class="ba6-top">
                    <span class="ba6-main-icon ba-bg-blue1">
                        <builderall-icon code='email-marketing-5'></builderall-icon>
                    </span>
                    <a :href="view.routes.mailingboss" class="ba6-title">{{ t.checkout_title_plan_mb_starter_toolannual_brl }}</a>
                </div>
                <hr class="ba6-card-line">
                <div v-if="view.routes.upgrade_mailingboss == null" class="ba6-main">
                    <div class="ba6-statistics">
                        <div class="ba6-s-top">
                            <div class="ba6-icon">
                                <builderall-icon code='fda8'></builderall-icon>
                            </div>
                            <div class="ba6-subtitle">{{ t.email_sent }}</div>
                        </div>
                        <span class="ba6-s-number" v-text="mbData.sents"></span>
                    </div>
                    <hr class="ba6-s-line">
                    <div class="ba6-statistics">
                        <div class="ba6-s-top">
                            <div class="ba6-icon">
                                <builderall-icon code='f9a1'></builderall-icon>
                            </div>
                            <div class="ba6-subtitle" v-text="t.open_rate"></div>
                        </div>
                        <span class="ba6-s-number" v-text="formattedOpenRate"></span>
                    </div>
                </div>
                <div v-else class="ba6-require-upgrade">
                    <a :href="view.routes.upgrade_mailingboss" class="ba-btn ba-md ba-blue" v-text="t.set_up_your_first_email"></a>
                </div>
            </div>
        </builderall-loader>
    </div>
</template>

<script>
    export default {
        name: "ba6-mailingboss-statistics",
        props: ['view'],
        data() {
            return {
                mbData: {
                    lists: 0,
                    subscribers: 0,
                    sents: 0,
                    open_rate: 0,
                },
                showLoading: false,
                t: null
            }
        },
        created(){
            this.t = this.view.translations;
            if(this.view.routes.upgrade_mailingboss == null){
                this.getMbStatistics();
            }
        },
        computed: {
          formattedOpenRate() {
            if(!this.mbData.hasOwnProperty('open_rate') || !this.mbData.open_rate){
              return '0.00%';
            }

            const truncatedRate = Math.floor(this.mbData.open_rate * 100) / 100;
            return `${truncatedRate.toFixed(2)}%`;
          }
        },
        methods: {
            getMbStatistics(){
                const headers = {
                    Accept: 'application/json',
                    Authorization: this.view.token
                };

                fetch(this.view.routes.orchestrator+'/api/v1/office/dashboard-data/mailingboss-5', {
                    method: 'GET',
                    headers: headers
                })
                    .then(response => response.json())
                    .then(result => {
                        if(Object.keys(result.data).length > 0){
                            this.mbData = {
                              lists: result.data.hasOwnProperty('lists') ? result.data.lists : 0,
                              subscribers: result.data.hasOwnProperty('subscribers') ? result.data.subscribers : 0,
                              sents: result.data.hasOwnProperty('sents') ? result.data.sents : 0,
                              open_rate: result.data.hasOwnProperty('open_rate') ? result.data.open_rate : 0,
                          };
                        }
                    })
                    .catch(error => {
                        console.error('getMbStatistics data error', error);
                    })
                    .finally(f => this.showLoading = false)
            },
            decodeString(string) {
              return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent;
            },
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/mailingboss/MailingbossStatistics.vue